
import Vue from 'vue'
// 此处暂时引入所有的element组件，后期用的少的话就再按需引入
import './filters/formatDate'
import './filters/phoneFormat'
import ElementUI from 'element-ui';
import "./common/css/reset.css";
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import {post,get ,put,$delete, imgUrl}  from './utils/http'
import _ from 'lodash'
import Print from '@/plugs/print'
Vue.use(Print) // 注册
Vue.prototype.userInfo = JSON.parse(localStorage.getItem('userMessage') || '{}');

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$put = put;
Vue.prototype.$delete = $delete;
Vue.prototype.customer = {
  phone:''
};
Vue.prototype.$imgUrl = imgUrl;
Vue.use(ElementUI);



Vue.prototype.$eventBus = new Vue();

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js